/**
 * Server-Sent Events handling
 */
import * as React from 'react';
import { apiCall } from '../../../_common/platform/ts/AqlUtility';
import { config } from './config';
import { IGlob } from './Glob';
import * as Utilities from '../../../_common/platform/ts/Utilities';
interface ITableCounters {
    [table: string]: number;
}
export class ServerEvents {
    private glob: IGlob;
    private userId: number;
    private eventSource: EventSource;
    private withCredentials: boolean;
    private max_retry_time = 3000;

    private tableCounters: ITableCounters = {};
    private entityModelEditing: boolean = false;

    private appSSEHandlers: (IGlob) => void;

    constructor(glob: IGlob, withCredentials?: boolean) {
        this.glob = glob;
        if (withCredentials != null) {
            this.withCredentials = withCredentials;
        }
    }

    public connect(userId: number) {
        this.userId = userId;
        let url = config.API_ENDPOINT + config.SSE_ENDPOINT || '/sse'; 
        if (this.userId != null) {
            url = url + ('?userid='+this.userId);
        }
        
        const options = this.withCredentials != null ? { withCredentials: this.withCredentials } : {};

        this.eventSource = new EventSource(url, options);

        this.loadTableCounters().done(() => {
            
            this.eventSource.onmessage = (event) => {
                this.handleMessage(event);
            };

            this.eventSource.addEventListener('update', (event) => {
                console.log('Raw event:', event);
                console.log('Data:', event.data);
                console.log('Last event ID:', event.lastEventId);
            });

            this.eventSource.addEventListener('liveReload', (event) => {
                this.doLiveReload(event.data);
            });

            this.eventSource.addEventListener('tableUpdate', (event) => {
                const { table, counter } = JSON.parse(event.data);

                if (table.toLowerCase() === 'wwentitymodel') {
                    // Do not add remaiders for self-editing entity models
                    if (this.entityModelEditing === false) {
                        const remainderID = Utilities.getNewID();
                        const _reactContent: React.JSX.Element = (
                            <div className="btn btn-default btn-xs" onClick={this.doReload}>
                                {'Reload'}
                            </div>
                        );
                        this.glob.AppActions.showNotification_Info(
                            'System is updated and client need to be reloaded',
                            null,
                            {
                                manualDestroy: true,
                                remainder: true,
                                reactContent: _reactContent,
                                details: { id: remainderID }
                            }
                        );
                    }
                }

                this.tableCounters[table] = counter;
            });

            this.eventSource.addEventListener('wsUpdate', (event) => {
                const { ws, dateUpdated, updatedBy } = JSON.parse(event.data);

                this.glob.AppActions.workspaceNotifyForeignUpdate(ws, dateUpdated, updatedBy);
            });

            this.eventSource.onerror = (event) => {
                this.handleError(event);
            };

            this.eventSource.onopen = (event) => {
                console.log('SSE connection opened');
            };

            if (typeof this.appSSEHandlers === 'function') {
                this.appSSEHandlers(this.glob);
            }

        });
    }

    public disconnect() {
        this.eventSource.close();
        this.userId = null;
    }

    public getEventSource() {
        return this.eventSource;
    } 

    public setAppSSEHandlers(callback) {
        this.appSSEHandlers = callback;
    }

    public setEntityModelEditing(editing) {
        this.entityModelEditing = editing;
    }

    private loadTableCounters() {
        const def = $.Deferred();
        apiCall<{ table: string; counter: number }[]>(
            this.glob.AppActions,
            'getTableCounters',
            {},
            {
                endPoint: config.getAPIEndpoint() + '/auth'
            }
        )
            .done((resp) => {
                resp.result.forEach((value) => {
                    this.tableCounters[value.table] = value.counter;
                });
            })
            .always(() => {
                def.resolve();
            });

        return def;
    }

    private handleMessage = (event) => {
        console.log(event.data);
    };

    private handleError = (event) => {
        if (this.eventSource) {
            if (this.eventSource.readyState === EventSource.CLOSED) {
                // reconnect with new object
                this.eventSource.close();
                this.eventSource = null;
                // reconnect after random timeout < max_retry_time
                const timeout = Math.round(this.max_retry_time * Math.random());
                setTimeout(() => this.connect(this.userId), timeout);
            }
        }
    };

    // Reload when new frontend, identified by meta build number is delivered by backend
    private doLiveReload(build_from_server) {
        const build = document.getElementsByTagName('meta')['build'].content;
        // In development environment the build is undefined, or set to "0"
        if (build == null || build === '' || build === '0') {
            return;
        }

        console.log('SVR:', build_from_server, 'LCL:', build);

        if (build !== build_from_server) {
            console.log('RELOAD at ' + new Date().toString());

            if ('caches' in window) {
                caches.keys().then((names) => {
                    // Delete all the cache files
                    names.forEach((name) => {
                        caches.delete(name);
                    });
                });
            }

            window.location.reload();
        }
    }

    private doReload() {
        window.location.reload();
    }
}
